import { versionNumberStorageKey } from './storage-key';
import { resetStorage } from './storage-utils';
export const getStorageVersionNumber = (storage) => {
    return storage.getItem(versionNumberStorageKey);
};
export const setStorageVersionNumber = (storage, versionNumber) => {
    storage.setItem(versionNumberStorageKey, versionNumber || 'unknown');
};
/**
 * Compares the current version number to the cached version number to determine whether the cached data is valid.
 *
 * TODO: In future this may be less aggressive, e.g. minor version differences may not be invalid. #286579
 */
export const isStorageCacheValid = (storage, versionNumber) => {
    if (!versionNumber)
        return false;
    return getStorageVersionNumber(storage) === versionNumber;
};
/**
 * Updates the version number of the provided storage.
 *
 * Resets the storage if the cached data is invalid for the new version number.
 */
export const updateStorageVersionNumber = (storage, versionNumber) => {
    // Reset local storage if cached data is invalid.
    if (!isStorageCacheValid(storage, versionNumber))
        resetStorage(storage);
    setStorageVersionNumber(storage, versionNumber);
};
